import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import MyProSidebar from "../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../COMPONENTS/navbar/Topbar";
import Header from "../../COMPONENTS/header/Header";
import { useContext, useEffect, useState } from "react";
import axios from 'axios';
import AuthContext from "../../CONTEXT/AuthProvider";

function Logs() {
  const [logHistory, setLogHistory] = useState([]);

  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken

  useEffect(() => {
    axios
      .get("/api/logs")
      .then((response) => {
        const dataResponse = response.data.map((logs, index) => ({
          ...logs,
          rowNumber: index + 1,
        }));
        setLogHistory(dataResponse);
      })
      .catch((error) => {
        //console.log(error);
      });
  }, []);


  const columns = [
    {
      field: "rowNumber",
      headerName: "#",
      flex: 0.2,
    },
    {
      field: "username",
      headerName: "Username",
      flex: 0.4,
    },
    {
      field: "subscriber_name",
      headerName: "Subscriber Name",
      flex: 1.3,
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.4,
    },
    {
      field: "action_date_time",
      headerName: "Date & Time",
      flex: 0.7,
    }
  ];
  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="10px">
          <Box m="10px">
            <Header
              title="LOG HISTORY"
              subtitle="View all logs in the system"
            />
            <Box
              m="40px 0 0 0"
              height="100vh"
              sx={{
                "& .MuiDataGrid-root": {
                  border: "none",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "none",
                },
                "& .name-column--cell": {
                  color: "#2e7c67",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#bbbbbb",
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: "#f2f0f0",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: "#a4a9fc",
                },
                "& .MuiCheckbox-root": {
                  color: `${"#1e5245"} !important`,
                },
                "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                  color: `${"#525252"} !important`,
                },
              }}
            >
              <DataGrid
                rows={logHistory}
                columns={columns}
                components={{ Toolbar: GridToolbar }}
              />
            </Box>
          </Box>
        </Box>
      </main>
    </div>
  );
}

export default Logs;